<template>
    <div>
        <!-- тут же рендерим тосты -->
        <ToastContainer></ToastContainer>
    </div>
</template>

<!-- Тут должны быть глобально доступные действия -->

<script lang="ts">
import { defineComponent } from 'vue';
import ToastContainer from './ToastContainer.vue';
import { useNotificationsCountUpdater } from '../notifications/counter/useNotificationsTimer';
import { useSignalR } from './useSignalRHub';

export default defineComponent({
    name: 'CommonApp',
    components: { ToastContainer },
    setup() {

        // notifications counter - глобальный
        // как это работает - таймер обновляет счетчик и шлет событие подписчикам
        // подписчики уже обновляют свое состояние на основе полученных данных
        useNotificationsCountUpdater();

        // SignalR - глобальный
        // принимает уведомления для пользователя, создает тосты (TODO: нужно разделение)
        const hub = useSignalR();

        return {};
    },
});
</script>